export default __webpack_public_path__ + "static/29-494aee61dd3e6e8db3f10dc7af8b2814.png";